// @ts-nocheck
import { NaicsQueryPayload } from "../../types/taxonomy";
import { formatStandardNumber } from "../../utils/numberUtils";
import { formatCurrency } from "../../utils/numberUtils";
import { IndustryParams } from "../types/companyFilter";
import { MinMaxValue } from "../types/companySearch/MI";
import { DepthSelectOption } from "../types/misc";
import {
  groupDepthTreeIds,
  naicsToDepthSelectOption,
  transformIntoDepthSelectOptionTree,
} from "./dataUtils";

export function naicsPayloadToDepthSelectOptionTree(
  naicsData: NaicsQueryPayload
): DepthSelectOption[] {
  return transformIntoDepthSelectOptionTree(
    naicsData?.naics2012?.data || [],
    naicsToDepthSelectOption
  );
}

export function getNaicsRootIds(
  filter: IndustryParams,
  naicsNameCache: NaicsQueryPayload
): string[][] {
  const naicsDepthTree: DepthSelectOption[] =
    naicsPayloadToDepthSelectOptionTree(naicsNameCache);
  return [
    getRootOfDepthTreeGroup(filter?.naics2012Ids || [], naicsDepthTree),
    getRootOfDepthTreeGroup(filter?.excludedNaics2012Ids || [], naicsDepthTree),
  ];
}

function getRootOfDepthTreeGroup(ids: any[], depthTree: DepthSelectOption[]) {
  const groupedIds: any[][] = groupDepthTreeIds(ids, depthTree);
  return groupedIds.map((group: any[]) => group[0]);
}

interface GenerateMinMaxLabelOptions {
  isCurrency?: boolean;
  value: MinMaxValue<number>;
}

function getFormattedNumber(isCurrency: boolean, value: number): string {
  return isCurrency ? formatCurrency(value, true) : formatStandardNumber(value);
}

export const generateMinMaxLabel = (
  options: GenerateMinMaxLabelOptions
): string => {
  const { value, isCurrency = false } = options;
  const min: number | undefined = value?.min;
  const max: number | undefined = value?.max;

  if (min == null && max == null) {
    return;
  }

  if (min == null) {
    return `Less than ${getFormattedNumber(isCurrency, max as number)}`;
  } else if (max == null) {
    return `Greater than ${getFormattedNumber(isCurrency, min)}`;
  } else {
    return `Between ${getFormattedNumber(
      isCurrency,
      min
    )} and ${getFormattedNumber(isCurrency, max)}`;
  }
};
